import { lazyLoad } from 'utils/loadable';

export const UsefulInfoListPage = lazyLoad(
  () => import('./index'),
  module => module.UsefulInfoListPage,
);
